module.exports = __webpack_public_path__ + "static/media/goal4.654bafab.svg";